import React, { Component } from 'react'
import styled from 'styled-components'

const Toast = styled.div`
    background-color: ${props => props.error ? '#f44336' : '#4caf50'};
    visibility: hidden;
    min-width: 250px;
    color: #fff;
    text-align: center;
    border-radius: 2px;
    padding: 16px;
    position: fixed;
    z-index: 1;
    left: auto;
    right: 24px;
    top: 10%;
    font-size: 1rem;
    border-radius: 4px;
    font-size: 0.875rem;
    box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12);

    &.show{
      visibility: visible;
      -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
      animation: fadein 0.5s, fadeout 0.5s 2.5s;
    }

    @-webkit-keyframes fadein {
      from {top: 0; opacity: 0;} 
      to {top: 10%; opacity: 1;}
    }

    @keyframes fadein {
      from {top: 0; opacity: 0;}
      to {top: 10%; opacity: 1;}
    }

    @-webkit-keyframes fadeout {
      from {top: 10%; opacity: 1;} 
      to {top: 0; opacity: 0;}
    }

    @keyframes fadeout {
      from {top: 10%; opacity: 1;}
      to {top: 0; opacity: 0;}
    }
`

export default class Toaster extends Component {
    
    render() {
      const { isActive, error, msg=""} = this.props;
      return (
        <Toast className={isActive ? 'snackbar show' : 'snackbar'} error={error}>
          {msg}
        </Toast>
      )
    }
}


// WEBPACK FOOTER //
// ./src/Containers/VideoGenerator/components/Toaster/Toaster.jsx